<div class="container indent-background">
  <div class="row">
    <div class="col-sm-6 text-center">
      <img src="/assets/home-1.png" class="home-page-images">
    </div>
    <div class="col-sm-6 text-center">
      <img src="/assets/home-2.png" class="home-page-images">
    </div>
  </div>
  <div class="row">
    <div class="col-sm-6 text-center">
      <img src="/assets/home-3.png" class="home-page-images">
    </div>
    <div class="col-sm-6 text-center">
      <img src="/assets/home-4.png" class="home-page-images">
    </div>
  </div>
  <!-- <div class="row">
    <div class="col-6 text-center">
      <a href="https://www.etsy.com/shop/INKfectionCollection" target="_new">
        <img src="/assets/buttons/stock-tattoos.png">
      </a>
    </div>
    <div class="col-6 text-center">
      <img src="/assets/buttons/custom-tattoos.png">
    </div>
  </div> -->
</div>
